/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../static/images/ALFRED_BLACK_SVG.svg';
import LogoWs from '../static/images/LoginIMG.png';
import { useDispatch } from 'react-redux';
import { RegExpValidator } from '../core/regExp-generic';
import { ErrorsIcon } from '../components/Icons/errorIcon';
import OtpInput from 'react-otp-input';
import { BusinessController } from '../core/controller/BusinessCtrl';
import { businessLoginDTO } from '../interfaces/businessInterface';
import { ArrowSmallLeftIcon } from '@heroicons/react/24/outline';

export const PasswordForgot = () => {
    const businessController = new BusinessController()
    const [state, setState] = useState<any>({
        email: '',
        code: '',
        isCode: false,
        msgCode: 'Enter the code sent to your email',
        msgErrors: '',
        isPassTemp: false,
        msgPassTemp: '',
        error: false
    });

    const [validPass, setvalidPass] = useState<any>({
        tempPass: '',
        newPass: '',
    });

    const [actinValid, setactinValid] = useState('newPass');
    const [successPass, setSuccessPass] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [otp, setOtp] = useState<any>('');
    const [titleForm, settitleForm] = useState<any>({
        newPass: {
            title: 'Forgot your password?',
            subTitle: 'Please enter the email with the one registerer so we can send you a new password'
        }
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        if (!RegExpValidator[name].test(value)) {
            setErrors((prevErrors: any) => ({ ...prevErrors, [name]: true }));
            setIsFormValid(false);
        } else {
            setErrors((prevErrors: any) => ({ ...prevErrors, [name]: false }));
            setIsFormValid(true);
        }

        setState((prevProps: any) => ({
            ...prevProps,
            [name]: value
        }))
    }

    const handleChangePinCode = async (event: any) => {
        try {
            setOtp(event)
            if (event.length === 4) {
                const dataFormSubmit: businessLoginDTO = {
                    'email': state.email,
                    'code': event
                }
                const response = await businessController.businessPasswordValidate(dataFormSubmit)
                const { data } = response

                if (data.statusCode === 202) {
                    setOtp('')
                    setSuccessPass(true)
                    setIsFormValid(true);
                    setState((prevProps: any) => ({
                        ...prevProps,
                        isCode: false,
                        isPassTemp: false,
                        msgPassTemp: 'A temporary password was sent to your email for login'
                    }))

                    setTimeout(() => {
                        navigate('/');
                        setSuccessPass(false)
                    }, 8000);

                } else {
                    setOtp('')
                    setState((prevProps: any) => ({
                        ...prevProps,
                        error: true,
                        isCode: false,
                        isPassTemp: false,
                        msgPassTemp: ''
                    }))
                }
            }

        }
        catch (error) {
            setOtp('')
        }
    }

    const handleSubmit = async (event: any) => {
        try {
            event.preventDefault();
            setState((prevProps: any) => ({
                ...prevProps,
                error: false
            }));
            const dataForm: any = {
                'email': state.email
            }
            const { data } = await businessController.businessPasswordRecovery(dataForm)

            if (data.statusCode === 202) {
                setState((prevProps: any) => ({
                    ...prevProps,
                    isCode: true
                }))
                const fechaActual = new Date();
                const minutosActuales = fechaActual.getMinutes();
                const sumaMinutos = 5;

                const nuevaFecha = new Date(fechaActual);
                nuevaFecha.setMinutes(minutosActuales + sumaMinutos);
                console.log(nuevaFecha.getMinutes())
                sessionStorage.setItem('time', nuevaFecha.getMinutes().toString())
                localStorage.setItem('email', state.email)
                navigate('/forgot-password-validate');
            } else {
                setState((prevProps: any) => ({
                    ...prevProps,
                    error: true,
                    msgErrors: data.message
                }))
            }
        }
        catch (error) {

        }
    }

    const handleNavigate = (routerUrl: string) => navigate(routerUrl)

    return (
        <>
            <div className="flex h-screen w-screen">
                <div className='flex flex-col items-center justify-center w-full gap-10'>
                    <div className='login-section-img w-1/2 pl-[70px]'>
                        <img src={Logo} alt="alfredpay logo" className='logo-login' />
                        <div className="
                            w-32
                            flex
                            items-center
                            text-[#000]
                            text-[1rem]
                            not-italic
                            font-[Montserrat]
                            font-semibold
                            leading-[150%]
                            cursor-pointer
                        "
                        onClick={() => handleNavigate('/')}
                        >
                            <ArrowSmallLeftIcon className='w-6 h-6 mr-2' />  Go back
                        </div>
                    </div>
                    <div className='w-[80%]'>
                        <p className='login-welcome mb-[20px]'>{titleForm[actinValid].title}</p>
                        {
                            successPass ?
                                <>
                                    <div className='mb-[5rem]'>
                                        <p className='text-16-400'>
                                            An email has been sent to
                                            <span className='text-16'>{' ' + state.email + ' '}</span>,
                                            if you can find it please check the spam inbox.
                                        </p>
                                    </div>
                                    <div className='text-16-500'>
                                        <span>Didn’t received it?</span>
                                    </div>
                                </>
                                :
                                <div>
                                    <p className='login-welcome-sub'>{titleForm[actinValid].subTitle}</p>
                                </div>
                        }

                    </div>

                    <form action="" className='flex flex-col gap-4 items-center w-[70%]' autoComplete="off" onSubmit={handleSubmit}>
                        {state.error &&
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full text-center" role="alert">
                                <span className="block sm:inline">{state.msgErrors || 'An internal error has occurred.'}</span>
                            </div>
                        }

                        <div className="flex flex-col w-[90%] gap-4">
                            <label htmlFor="" className='login-Label' >Email</label>
                            <input
                                type="email"
                                name="email"
                                required
                                className={`login-input w-full h-10 p-[10px] ${errors.email ? 'errors-input' : ''}`}
                                onChange={handleChange}
                                value={state.email}
                            />

                            {errors.email && (
                                <div className='flex errors-msm'>
                                    <ErrorsIcon className='mr-2 w-[1.5rem]' /> email not registered, please try again
                                </div>
                            )
                            }
                        </div>


                        <button
                            type="submit"
                            disabled={!isFormValid}
                            className={`${isFormValid ? 'btn-active' : 'btn-disabled'} text-white text-center w-[90%] p-[0.7rem] border rounded-full login-btn-text`}
                        >
                            Send Email
                        </button>


                    </form>
                </div>
                <img className='w-full object-cover login-res' src={LogoWs} alt="" />
            </div>
        </>

    )
}